import React from 'react';

interface GameStatsProps {
    score: number;
    level: number;
    lives: number;
}

const GameStats: React.FC<GameStatsProps> = ({ score, level, lives }) => {
    return (
        <div style={{
            display: 'flex',
            gap: '30px',
            marginBottom: '20px',
            color: '#FFFFFF',
            fontSize: '18px'
        }}>
            <div>SCORE: <span style={{ color: '#FFFF00' }}>{score.toLocaleString()}</span></div>
            <div>LEVEL: <span style={{ color: '#00FF00' }}>{level}</span></div>
            <div>LIVES: <span style={{ color: '#FF0000' }}>{'♥'.repeat(lives)}</span></div>
        </div>
    );
};

export default GameStats; 